import React from "react";
import { List, ListItemText, Tooltip, Typography } from "@mui/material";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import { ALLOWED_IMAGE_EXTENSIONS } from "../../constants/Configurator.constants";

// GIF and AVIF used to be listed here but tenant-service has never accepted
// either, so an admin who followed the guidance had the upload rejected on
// Publish. The list is now the same one the upload is checked against.
// APNG is absent for the opposite reason: it is carried in a .png file and
// reported as image/png, so it is already covered by PNG.
const ImageGuidelinesTooltip = ({
  ratio = "10:2",
  placement = "right",
  maxSize = "100KB",
  extensions = ALLOWED_IMAGE_EXTENSIONS,
}) => {
  return (
    <Tooltip
      title={
        <>
          <Typography>
            Recommended ratio: <b>{ratio}</b>
          </Typography>
          <Typography>
            Maximum file size: <b>{maxSize}</b>
          </Typography>
          <Typography>Extensions allowed:</Typography>
          <List
            dense
            sx={{
              paddingLeft: 2,
              "& .MuiListItemText-primary": { fontSize: "0.75rem" },
            }}
          >
            {extensions.map((extension) => (
              <ListItemText key={extension}>
                <b>{extension.toUpperCase()}</b>
              </ListItemText>
            ))}
          </List>
        </>
      }
      placement={placement}
    >
      <HelpOutlineOutlinedIcon color="primary" />
    </Tooltip>
  );
};

export default ImageGuidelinesTooltip;
